<button class="btn btn-primary btn-sm" disabled>
    <span>{{ 'BUTTON_TEXT.GOODS' | translate }}</span>
</button>
